import React from 'react';

import { SVGPropsType } from 'src/types';

function ArrowUp(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M5.77783 10.2222L12.0001 4M12.0001 4L18.2223 10.2222M12.0001 4V20"
                stroke={stroke}
                strokeWidth="1.77778"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default ArrowUp;
